import { Button, CircularProgress, Stack, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import Scrollbar from 'components/ScrollBar';
import { H4 } from 'components/Typography';

// --------------------------------------------------------------
const PopUpConfirmation = ({ handleCancel, handleApprove, disableButton }) => {
    const downSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    return (
        <Box>
            <H4 mb={4} align={'center'}>
                Are you sure to DELETE this registration?
            </H4>
            <Scrollbar
                autoHide={false}
                style={{
                    maxHeight: downSm ? 300 : '',
                }}
            ></Scrollbar>

            <Stack
                direction="row"
                spacing={1}
                mt={4}
                sx={{ justifyContent: 'center' }}
            >
                <Button
                    disabled={disableButton}
                    variant="contained"
                    onClick={() => handleApprove()}
                    color="error"
                >
                    {disableButton ? (
                        <>
                            Processing . . .
                            <CircularProgress size={20} />
                        </>
                    ) : (
                        'Delete'
                    )}
                </Button>

                <Button
                    disabled={disableButton}
                    variant="outlined"
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
            </Stack>
        </Box>
    );
};

export default PopUpConfirmation;
